import { useEffect } from 'react';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { userManager } from 'services/oidcConfig';
import { resetUser } from 'utils/mixpanel';
import { snackbar } from 'shared/helpers/snackbar';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { setUser } from 'store/slices/userSlice';
import { TruncatedText } from 'shared/ui/truncated-text/truncated-text';
import cls from './user-menu.module.scss';
import { useTranslation } from 'hooks';

export const UserMenu: React.FC = () => {
  const user = useAppSelector(state => state.user.user);
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const initial = user?.name?.charAt(0).toUpperCase() || 'U';

  useEffect(() => {
    if (user) return;
    userManager.getUser().then(oidcUser => {
      if (oidcUser && !oidcUser.expired) {
        dispatch(
          setUser({
            email: (oidcUser.profile.email as string) || null,
            name: (oidcUser.profile.name as string) || null,
            sub: oidcUser.profile.sub || null,
          })
        );
      }
    });
  }, [user, dispatch]);

  const handleLogout = async () => {
    try {
      resetUser();
      await userManager.signoutRedirect();
    } catch (err: any) {
      snackbar(err?.message || 'Logout failed');
    }
  };

  return (
    <Menu>
      <MenuButton className={cls.button}>{initial}</MenuButton>
      <MenuItems anchor='bottom end' className={cls.userMenu}>
        <div className={cls.userHeader}>
          <div className={cls.userAvatar}>{initial}</div>
          <p className={cls.email}>
            <TruncatedText text={user?.email || 'Unknown'} place='bottom' />
          </p>
        </div>
        <MenuItem as={'div'} onClick={handleLogout} className={cls.item}>
          {t('logout')}
        </MenuItem>
      </MenuItems>
    </Menu>
  );
};
